
// AdminEmployees.jsx
import React, { useState } from 'react';
import { Users, UserPlus } from 'lucide-react';
import TabPageLayout from 'modules/swiftboard/components/TabPageLayout'; 
import Clients from './client-management/Clients';
import Admin from './admin-management/Admin';
import Employee from './employee-management/Employee';
import useUrlTab from "modules/swiftboard/components/useUrlTab";
const UserManagement = () => {
  const [activeTab, setActiveTab] = useUrlTab(["clients", "admins", "employees"]);
  const [tabCounts, setTabCounts] = useState({});

  const setTabCount = (tabId) => (count) =>
    setTabCounts((prev) => (prev[tabId] === count ? prev : { ...prev, [tabId]: count }));

  const userManagementTabs = [
    {
      id: 1,
      label: 'Clients',
      icon: <Users size={18} />,
    },
    {
      id: 2,
      label: 'Admins',
      icon: <UserPlus size={18} />,
    },
    {
      id: 3,
      label: 'Employees',
      icon: <UserPlus size={18} />,
    }
  ].map((tab, index) => ({
    ...tab,
    badge:
      index === activeTab && tabCounts[tab.id] !== undefined
        ? { count: tabCounts[tab.id], compact: true }
        : undefined,
  }));


  const handleTabChange = (index, tab) => {
    setActiveTab(index);
  };




  return (
    <TabPageLayout
      tabs={userManagementTabs}
      activeTab={activeTab}
      onTabChange={handleTabChange}
    >
      {activeTab === 0 && <Clients onTotalCountChange={setTabCount(1)} />}
      {activeTab === 1 && <Admin onTotalCountChange={setTabCount(2)} />}
      {activeTab === 2 && <Employee onTotalCountChange={setTabCount(3)} />}
    </TabPageLayout>
  );
};

export default UserManagement;